module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', [_c('div', {
    staticClass: "col-md-9 margin-left-14",
    on: {
      "click": _vm.navigatoTo
    }
  }, [(_vm.notifyUser.typeAlert === 'status_changed') ? _c('a', [_vm._v(" \n\t\t\t\t\t" + _vm._s(_vm.notifyUser.actionedByUser.name) + " " + _vm._s(_vm.notifyUser.status) + " cadastro do cliente " + _vm._s(_vm.notifyUser.client.name) + ".\n\t\t\t\t\t"), _c('i', {
    staticClass: "fa fa-check text-success"
  })]) : _vm._e(), _vm._v(" "), (_vm.notifyUser.typeAlert === 'client_added') ? _c('a', [_vm._v(" \n\t\t\t\t" + _vm._s(_vm.notifyUser.actionedByUser.name) + " acabou de inseriu um novo cadastro de cliente. Nome: " + _vm._s(_vm.notifyUser.client.name) + ".\n\t\t\t\t"), _c('i', {
    staticClass: "fa fa-check text-success"
  })]) : _vm._e(), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', {
    staticClass: "col-md-1",
    on: {
      "click": _vm.close
    }
  }, [_c('i', {
    staticClass: "fa fa-window-close icon"
  })]), _vm._v(" "), _c('div', {
    staticClass: "space-50"
  }), _vm._v(" "), _c('small', {
    staticClass: "pull-right"
  }, [_vm._v(_vm._s(_vm._f("time")(_vm.notifyUser.date)))])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-c4aa1f4a!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/app/general_notification_components/NotifyUserOnClient.vue
// module id = 858
// module chunks = 2